var _effectorFileName = "/builds/gmini/front-common/src/metrika/metrika.ts";
import { createGoal } from "./utils";
export var goals = {
  // TODO добавить после рефакторинга панелей
  foldViewer: createGoal('FOLD_VIEWER'),
  foldDependencies: createGoal('FOLD_DEPENDENCIES'),
  foldClassifier: createGoal('FOLD_CLASSIFIER'),
  foldGroupSettings: createGoal('FOLD_GROUP_SETTINGS'),
  expandViewer: createGoal('EXPAND_VIEWER'),
  expandDependencies: createGoal('EXPAND_DEPENDENCIES'),
  expandClassifier: createGoal('EXPAND_CLASSIFIER'),
  expandGroupSettings: createGoal('EXPAND_GROUP_SETTINGS'),
  openFilter: createGoal('OPEN_FILTER'),
  filterSelectIncluded: createGoal('SELECT_FILTER_INCLUDED'),
  filterSelectNotIncluded: createGoal('SELECT_FILTER_NOT_INCLUDED'),
  filterSelectAll: createGoal('SELECT_FILTER_ALL'),
  runCheckup: createGoal('RUN_CHECKUP'),
  runEstimation: createGoal('RUN_ESTIMATION'),
  downloadReportCheckup: createGoal('DOWNLOAD_REPORT_CHECKUP'),
  downloadReportEstimation: createGoal('DOWNLOAD_REPORT_ESTIMATION'),
  downloadCheckupRvtConfig: createGoal('DOWNLOAD_CHECKUP_RVT_CONFIG'),
  showCheckupRvtConfigHelp: createGoal('SHOW_CHECKUP_RVT_CONFIG_HELP'),
  showCheckupFormulaHelp: createGoal('SHOW_CHECKUP_FORMULA_HELP'),
  showEstimationFormulaHelp: createGoal('SHOW_ESTIMATION_FORMULA_HELP'),
  showUserMenu: createGoal('SHOW_USER_MENU'),
  addCheckupFormula: createGoal('ADD_CHECKUP_FORMULA'),
  addEstimationFormula: createGoal('ADD_ESTIMATION_FORMULA'),
  deleteEstimationFormula: createGoal('DELETE_ESTIMATION_FORMULA'),
  deleteCheckupFormula: createGoal('DELETE_CHECKUP_FORMULA'),
  confirmUpdatingModelVersion: createGoal('CONFIRM_UPDATING_MODEL_VERSION'),
  addModelDependency: createGoal('ADD_MODEL_DEPENDENCY'),
  addClassifierDependency: createGoal('ADD_CLASSIFIER_DEPENDENCY'),
  menuNodeRightClick: createGoal('MENU_NODE_RIGHT_CLICK'),
  menuNodeButton: createGoal('MENU_NODE_BUTTON'),
  foldAllNodes: createGoal('FOLD_ALL_NODES'),
  deleteSeveralNodes: createGoal('DELETE_SEVERAL_NODES'),
  findFromDependencies: createGoal('FIND_FROM_DEPENDENCIES'),
  findFromViewer: createGoal('FIND_FROM_VIEWER'),
  findFromClassifier: createGoal('FIND_FROM_CLASSIFIER'),
  moveNodesFromOwn: createGoal('MOVE_NODES_FROM_OWN'),
  moveNodesFromOwnDnd: createGoal('MOVE_NODES_FROM_OWN_DND'),
  moveNodesFromDependencies: createGoal('MOVE_NODES_FROM_DEPENDENCIES'),
  moveNodesFromDependenciesDnd: createGoal('MOVE_NODES_FROM_DEPENDENCIES_DND'),
  selectViewerModeAll: createGoal('SELECT_VIEWER_MODE_ALL'),
  selectViewerModeHideUnchosen: createGoal('SELECT_VIEWER_MODE_HIDE_UNCHOSEN'),
  selectViewerModeTransparent: createGoal('SELECT_VIEWER_MODE_TRANSPARENT')
};